export default `
# ชนิดของราก

## Primary root

เป็นรากที่มีกำเนิดและเจริญเติบโตมาจาก Radicle รากชนิดนี้มักจะพุ่งดิ่งลงสู่ดินไปเรื่อยๆ ตอนโคนจะโตและค่อยๆเรียวเล็กไปจนถึงปลาย หน้าที่ส่วนใหญ่ใช้สำหรับเป็นหลักรับส่วนอื่นๆของพืชให้ทรงตัวอยู่ได้ จึงเรียกว่า รากแก้ว (Tap root) ซึ่งจะยาวและใหญ่กว่ารากอื่นๆทั้งหมด

## Secondary root

เป็นรากที่มีกำเนิดและเจริญเติบโตมาจาก Primary root เป็นรากที่เรียกว่ารากแขนง (Lateral root or Branch root) มักจะออกเฉียงลงไปในดินจนเกือบขนานไปกับพื้นดิน รากชนิดนี้อาจแตกแขนงออกเป็นทอดๆ มีกำเนิดออกมาจากเนื้อเยื่อ [Pericycle](#/tissue/pericycle) ในรากเดิม

![Primary and secondary root](rootTypePrimary)

## Adventitious root

เป็นรากที่ไม่ได้มีกำเนิดมาจาก Radicle และไม่เป็นแขนงของ Primary root นิยมเรียกว่า รากวิสามัญ อาจแตกออกตามโคนต้นของพืช ตามข้อของลำต้นหรือกิ่ง ตามใบ หรือจากกิ่งตอน เช่น

* รากฝอย (Fibrous root) เป็นรากเส้นเล็กมากมาย ขนาดโตสม่ำเสมอกัน งอกออกจากรอบๆโคนต้น
  พบในพืชใบเลี้ยงเดี่ยวเป็นส่วนใหญ่ เช่น รากข้าว ข้าวโพด หญ้า หมาก มะพร้าว ตาล กระชาย และในพืชใบเลี้ยงคู่บางชนิด เช่น รากต้อยติ่ง มันเทศ มันแกว มันสำปะหลัง รักเร่ ถั่วพู
  ![Fibrous root](rootTypeFibrous)

* รากค้ำจุน (Prop root)

* รากเกาะ (Climbing root)

* รากสังเคราะห์ด้วยแสง (Photosynthesis root)

* รากค้ำจุน (Prop root)

* รากเกาะ (Climbing root)

* รากสังเคราะห์ด้วยแสง (Photosynthesis root)

* รากหายใจ (Respiration root)

* รากกาฝาก (Parasitic root)
`


// WEBPACK FOOTER //
// ./src/pages/Root/rootTypeMarkdown.js